'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocation = setLocation;
exports.back = back;
exports.routeChangeSuccess = routeChangeSuccess;

var _actionTypes = require('./action-types');

function setLocation(setters) {
  return {
    setters: setters,
    type: _actionTypes.SET_LOCATION
  };
}

function back() {
  return {
    type: _actionTypes.BACK
  };
}

function routeChangeSuccess(router) {
  return {
    type: _actionTypes.ROUTE_CHANGE_SUCCESS,
    router: router
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ng-redux-route/lib/action-creaters.js
// module id = 208
// module chunks = 0